<form [formGroup]="form" (ngSubmit)="save()" class="assignment-form" aria-labelledby="dialog-title">
  <div class="d-flex justify-content-between align-items-center pe-4">
    <h2 mat-dialog-title id="dialog-title" class="mb-0">{{ dialogTitle }}</h2>
    <mat-form-field appearance="outline" floatLabel="always" class="field-selector mt-3">
      <mat-label>Add Fields</mat-label>
      <mat-select placeholder="Select fields to add"
        [value]="activeFields"
        (selectionChange)="updateFields($event.value)"
        multiple>
        @for (field of availableFields; track field) {
          <mat-option
            [value]="field.key">
            {{ field.label }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <mat-dialog-content class="dialog-content mt-0 pt-0">
    <mat-card class="form-card" role="group" aria-label="Assignment fields">
      <div class="form-grid">
        <!-- Consumer -->
        <div class="grid-label">
          <span>Consumer <span class="req" aria-hidden="true">*</span></span>
          <span class="cdk-visually-hidden">Required</span>
        </div>
        <div class="grid-control">
          <mat-form-field appearance="outline" floatLabel="always" style="width:100%;">
            <mat-label>Consumer</mat-label>
            <mat-select formControlName="consumer" required [disabled]="true" [value]="'COMMERCEPOINT'">
              <mat-option value="COMMERCEPOINT">CommercePoint</mat-option>
            </mat-select>
            @if (form.get('consumer')?.hasError('required')) {
              <mat-error>Consumer is required</mat-error>
            }
          </mat-form-field>
        </div>

        <!-- Location -->
        <div class="grid-label">
          <span>Location <span class="req" aria-hidden="true">*</span></span>
          <span class="cdk-visually-hidden">Required</span>
        </div>
        <div class="grid-control">
          <mat-form-field appearance="outline" floatLabel="always" style="width:100%;">
            <mat-label>Location</mat-label>
            <mat-select formControlName="location" required>
              @for (option of locationOptions; track option) {
                <mat-option [value]="option.value">
                  {{ option.label }}
                </mat-option>
              }
            </mat-select>
            @if (form.get('location')?.hasError('required')) {
              <mat-error>Location is required</mat-error>
            }
          </mat-form-field>
        </div>

        <!-- Dynamic Fields -->
        @for (fieldKey of activeFields; track fieldKey) {
          <div class="grid-label">
            <span>{{ getFieldLabel(fieldKey) }} <span class="req" aria-hidden="true">*</span></span>
            <span class="cdk-visually-hidden">Required</span>
          </div>
          <mat-form-field appearance="outline" floatLabel="always" style="width:100%;">
            <mat-label>{{ getFieldLabel(fieldKey) }}</mat-label>
            <mat-select [formControlName]="fieldKey" required>
              @for (option of getFieldOptions(fieldKey); track option) {
                <mat-option [value]="option">
                  {{ option }}
                </mat-option>
              }
            </mat-select>
            @if (form.get(fieldKey)?.hasError('required')) {
              <mat-error>This field is required</mat-error>
            }
          </mat-form-field>
          <button mat-icon-button
            type="button"
            class="remove-field-btn"
            (click)="removeField(fieldKey)"
            aria-label="Remove field">
            <mat-icon>delete</mat-icon>
          </button>
        }
      </div>
    </mat-card>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions-fixed">
    @if (isEditMode) {
      <button mat-raised-button color="warn" type="button" (click)="deleteAssignment()">
        <mat-icon aria-hidden="true">delete</mat-icon> Delete
      </button>
    }

    <span style="flex: 1"></span>

    <button mat-raised-button color="primary" type="button" mat-dialog-close (click)="close()">
      Cancel
    </button>

    <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid || activeFields.length === 0">
      <mat-icon aria-hidden="true">save</mat-icon> Save
    </button>
  </mat-dialog-actions>
</form>
